// schema naming conversions:
// material_mode -> material
// material.none -> material.geometry_only
// material.normal -> material.basic
// input_image.image_uri -> input_image.asset_id

import hyper3dImageTo3dModelGen2 from './Schema/hyper3d-image-to-3d-model_gen2'
import hyper3dRetextureModelPro from './Schema/hyper3d-retexture-model_pro'
import hyper3dTextTo3dModelGen2 from './Schema/hyper3d-text-to-3d-model_gen2'
import meshyAnimationModelPro from './Schema/meshy-animation-model_pro'
import meshyImageTo3dModelPro from './Schema/meshy-image-to-3d-model_pro'
import meshyMeshSegmentationModelPro from './Schema/meshy-mesh-segmentation-model_pro'
import meshyMeshSimplificationModelPro from './Schema/meshy-mesh-simplification-model_pro'
import meshyRetextureModelPro from './Schema/meshy-retexture-model_pro'
import meshyTextTo3dModelPro from './Schema/meshy-text-to-3d-model_pro'
import nanoBananaRender3dTo2dModelNb2Lite from './Schema/nano-banana-render-3d-to-2d-model_nb2-lite'
import tencentImageTo3dModelPro from './Schema/tencent-image-to-3d-model_pro'
import tencentMeshSegmentationModelPro from './Schema/tencent-mesh-segmentation-model_pro'
import tencentMeshSimplificationModelPro from './Schema/tencent-mesh-simplification-model_pro'
import tencentRetextureModelPro from './Schema/tencent-retexture-model_pro'
import tencentTextTo3dModelPro from './Schema/tencent-text-to-3d-model_pro'
import tripo3dAnimationModelDefault from './Schema/tripo3d-animation-model_default'
import tripo3dImageTo3dModelDefault from './Schema/tripo3d-image-to-3d-model_default'
import tripo3dMeshSegmentationModelDefault from './Schema/tripo3d-mesh-segmentation-model_default'
import tripo3dMeshSimplificationModelDefault from './Schema/tripo3d-mesh-simplification-model_default'
import tripo3dRetextureModelDefault from './Schema/tripo3d-retexture-model_default'
import tripo3dTextTo3dModelDefault from './Schema/tripo3d-text-to-3d-model_default'

// Order matters within an action: getNextGenerationSchema derives the provider
// list from array order, and the first eligible provider is the fallback
// (setAvailableGenerationProviders 0/1/many rules) - used when the active
// provider stops being eligible, or when the provider rolled by
// resolveInitialGenerationProvider is unavailable for the current settings.
// The initial provider for model generation comes from that weighted roll, not
// from this order; Meshy schemas still lead the generation actions so Meshy is
// the fallback engine. Retexture leads with Tripo3D so the Texture tab defaults
// to it instead of inheriting whatever engine the previously open tab left active.
export const MODEL_SOURCES = [
  meshyImageTo3dModelPro,
  meshyTextTo3dModelPro,
  tencentImageTo3dModelPro,
  tencentMeshSimplificationModelPro,
  tencentMeshSegmentationModelPro,
  meshyMeshSimplificationModelPro,
  tripo3dMeshSimplificationModelDefault,
  tripo3dMeshSegmentationModelDefault,
  meshyMeshSegmentationModelPro,
  tripo3dRetextureModelDefault,
  tencentRetextureModelPro,
  hyper3dRetextureModelPro,
  meshyRetextureModelPro,
  tencentTextTo3dModelPro,
  tripo3dImageTo3dModelDefault,
  tripo3dTextTo3dModelDefault,
  hyper3dTextTo3dModelGen2,
  hyper3dImageTo3dModelGen2,
  meshyAnimationModelPro,
  tripo3dAnimationModelDefault,
  nanoBananaRender3dTo2dModelNb2Lite,
]
